<template>
  <pt-life-experience-pavilion class="pt-life-experience-pavilion__page"></pt-life-experience-pavilion>
</template>

<script>
import PtLifeExperiencePavilion from 'cps/integral-mall-manage/pt-life-experience-pavilion/withData'
export default {
  name: 'pt-life-experience-pavilion__view',
  components: {
    'pt-life-experience-pavilion': PtLifeExperiencePavilion
  }
}
</script>
